import { BlockchainID } from 'multirpc-sdk';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

import { ALL_WHITELIST_BLOCKCHAINS_VALUE } from 'modules/projects/const';
import { RootState } from 'store';

import { mapMultichainToAapiV2 } from '../../utils/mapMultichainToAapiV2';
import { mapBtcMainnetChainIdToBtc } from './mapBtcMainnetChainIdToBtc';
import { getCurrentWhitelistChains } from './getCurrentWhitelistChains';
import { getRemovedChains } from './getRemovedChains';
import { updateWhitelistWithRemovedChains } from './updateWhitelistWithRemovedChains';

export interface FilterWhitelistParams {
  userEndpointToken: string;
  group?: string;
  currentBlockchains: BlockchainID[];
  dispatch: ThunkDispatch<RootState, unknown, AnyAction>;
}

export async function filterWhitelistIfNeeded(
  params: FilterWhitelistParams,
): Promise<void> {
  const { currentBlockchains, dispatch, group, userEndpointToken } = params;

  if (
    currentBlockchains.length === 0 ||
    currentBlockchains.includes(ALL_WHITELIST_BLOCKCHAINS_VALUE)
  ) {
    // If all chains are added to project, no need to filter whitelist
    return;
  }

  const { chains: whitelistChains, items: whitelistItems } =
    await getCurrentWhitelistChains({
      userEndpointToken,
      group,
      dispatch,
    });

  const currentChainIds = currentBlockchains
    .map(mapBtcMainnetChainIdToBtc)
    .map(mapMultichainToAapiV2);

  const removedChains = getRemovedChains({
    whitelistChains,
    currentChains: currentChainIds,
  });

  if (removedChains.length > 0) {
    // Check if all whitelist items will be removed (no whitelist items match current project chains)
    const remainingWhitelistChains = whitelistChains.filter(chain =>
      currentChainIds.includes(chain),
    );

    const isAllChainsRemoved = remainingWhitelistChains.length === 0;

    await updateWhitelistWithRemovedChains({
      userEndpointToken,
      group,
      removedChains,
      originalWhitelist: whitelistItems,
      isAllChainsRemoved,
      dispatch,
    });
  }
}
